<template>
  <div
    id="history"
    class="menucontent"
    v-if="showModal"
    style="overflow-y: auto; max-height: 100%"
  >
    <div class="inmenucontent animate__animated animate__bounceIn" :style="{ backgroundImage: createBackgroundString }">
      <button class="hidemenu" @click="hide">
        <i class="fas fa-times"></i>
      </button>
      <div class="ininmnct">
        <div class="menuhead"><i class="fas fa-history"></i> ประวัติ</div>
        <div class="row m-0 mt-3">
          <div class="col-2 p-0 leftdps">
            <div
              class="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link green active"
                id="v-pills-all-tab"
                data-toggle="pill"
                href="#v-pills-all"
                role="tab"
                aria-controls="v-pills-all"
                aria-selected="true"
                >ทั้งหมด</a
              >
              <a
                class="nav-link green"
                id="v-pills-dps-tab"
                data-toggle="pill"
                href="#v-pills-dps"
                role="tab"
                aria-controls="v-pills-dps"
                aria-selected="false"
                >ฝาก</a
              >
              <a
                class="nav-link red"
                id="v-pills-wd-tab"
                data-toggle="pill"
                href="#v-pills-wd"
                role="tab"
                aria-controls="v-pills-wd"
                aria-selected="false"
                >ถอน</a
              >
            </div>
          </div>
          <div class="col-10 p-0 containhislist">
            <div class="tab-content" id="v-pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-all"
                role="tabpanel"
                aria-labelledby="v-pills-all-tab"
              >
                <div
                  class="containerhis"
                  v-for="(data, index) in AllHistory"
                  :key="index"
                >
                  <div class="listht">
                    <table>
                      <tbody>
                        <tr v-if="data.amount">
                          <td class="text-success">
                            สำเร็จ
                            <span class="badge bg-success text-white">ฝาก</span>
                            <br />
                            <!-- <span
                              class="text-muted"
                              style="font-size: 11px"
                              v-if="data.description != '-'"
                              >{{ data.description }}</span
                            > -->
                          </td>
                          <td>
                            {{ data.amount }} บาท <br />
                            <span class="timehis"
                              >{{ data.date }} {{ data.time }}</span
                            >
                          </td>
                        </tr>
                        <tr v-if="data.credit_up">
                          <td class="text-success" v-if="data.status == 0">
                            สำเร็จ
                            <span class="badge bg-info text-white">ถอน</span>
                          </td>
                          <td class="text-warning" v-if="data.status == 1">
                            รอทำรายการ
                            <span class="badge bg-info text-white">ถอน</span>
                          </td>
                          <td class="text-danger" v-if="data.status == 2">
                            ยกเลิก
                            <span class="badge bg-info text-white">ถอน</span>
                            <br />
                            <span
                              class="text-muted"
                              style="font-size: 11px"
                              v-if="data.description != '-'"
                              >{{ data.description }}</span
                            >
                          </td>
                          <td>
                            {{ data.credit_up }} บาท <br />
                            <span class="timehis"
                              >{{ data.date }} {{ data.time }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade active"
                id="v-pills-dps"
                role="tabpanel"
                aria-labelledby="v-pills-dps-tab"
              >
                <div
                  class="containerhis"
                  v-for="(data, index) in Deposit"
                  :key="index"
                >
                  <!--  Loop list DPS -->
                  <div class="listht">
                    <table>
                      <tbody>
                        <tr>
                          <td class="text-success">
                            สำเร็จ <br />
                            <!-- <span
                              class="text-muted"
                              style="font-size: 11px"
                              v-if="data.description != '-'"
                              >{{ data.description }}</span
                            > -->
                          </td>
                          <td>
                            {{ data.amount }} บาท <br />
                            <span class="timehis"
                              >{{ data.date }} {{ data.time }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!--  END Loop list DPS -->
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-wd"
                role="tabpanel"
                aria-labelledby="v-pills-wd-tab"
              >
                <div
                  class="containerhis"
                  v-for="(data, index) in Withdraw"
                  :key="index"
                >
                  <!--  Loop list WD-->
                  <div class="listht">
                    <table>
                      <tbody>
                        <tr>
                          <td class="text-success" v-if="data.status == 0">
                            สำเร็จ
                          </td>
                          <td class="text-warning" v-if="data.status == 1">
                            รอทำรายการ
                          </td>
                          <td class="text-danger" v-if="data.status == 2">
                            ยกเลิก <br />
                            <span
                              class="text-muted"
                              style="font-size: 11px"
                              v-if="data.description != '-'"
                              >{{ data.description }}</span
                            >
                          </td>
                          <td>
                            {{ data.credit_up }} บาท <br />
                            <span class="timehis"
                              >{{ data.date }} {{ data.time }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!--  END Loop list WD -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlaymenu"></div>
  </div>
</template>

<script>
import { HTTP } from "@/services/http-common";
import { mapGetters } from "vuex";

export default {
  name: "historymodal-component",
  data() {
    return {
      showModal: false,
      Deposit: [],
      Withdraw: [],
      AllHistory: [],
    };
  },
  // mounted() {
  //   this.fetchAllData();
  // },
  methods: {
    show() {
      this.fetchAllData();
    },
    hide() {
      this.showModal = false;
      this.$emit("OpenMenuModalProp", true);
    },
    fetchAllData() {
      HTTP.get(`member/transaction`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
            );
          } else {
            this.Deposit = resp.data.deposit;
            this.Withdraw = resp.data.withdraw;
            this.AllHistory = resp.data.all;
            // console.log(resp.data.all);
            // const DwAll = [];
            // resp.data.deposit.forEach((item) => {
            //   DwAll.push(item);
            // });
            // resp.data.withdraw.forEach((item) => {
            //   DwAll.push(item);
            // });
            // const arrSortDate = DwAll.sort((a, b) => {
            //   if (a.date < b.date) {
            //     return 1;
            //   }
            //   if (a.date > b.date) {
            //     return -1;
            //   }
            //   return 0;
            // });

            // const arr = arrSortDate.sort((a, b) => {
            //   if (a.time < b.time) {
            //     return 1;
            //   }
            //   if (a.time > b.time) {
            //     return -1;
            //   }
            //   return 0;
            // });
            // console.log(arrSortDate);

            this.showModal = true;
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        });
    },
  },
  computed: {
    ...mapGetters(["WebSetting"]),
    createBackgroundString() {
      return `linear-gradient(140deg, ${this.WebSetting.color1}, #000000 95%), linear-gradient(180deg, #a78059 -30%, #f2d7a9 22%, #715236 72%, #f1bb73 112%)`;
    },
  },
};
</script>

<style></style>
